/**
 * @author renjie.fei
 * @desc 工具类
 */

// 寻找带有某个class的父节点
export function findParentNodeByClassName (node, className) {
  if (node.className.includes(className)) {
    return node
  }
  return findParentNodeByClassName(node.parentNode, className)
}

// 重复字符串str n次
export function repeat (str, n) {
  var res = ''
  while (n) {
    if (n % 2 === 1) { res += str }
    if (n > 1) { str += str }
    n >>= 1
  }
  return res
}

// 转为驼峰命名
export function camelCase (name) {
  return name && name.replace(/-(\w)/g, (origin, $1) => $1.toUpperCase())
}

// 添加cookie
export const addCookie = (name, value, expiresHours) => {
  let cookieString = name + '=' + escape(value) + '; path=/'
  // 判断是否设置过期时间
  if (expiresHours > 0) {
    let date = new Date()
    date.setTime(date.getTime + expiresHours * 3600 * 1000)
    cookieString = cookieString + '; expires=' + date.toUTCString()
  }
  document.cookie = cookieString
}

// 获取cookie
export const getCookie = name => {
  const $match = document.cookie.match(new RegExp(`${name}=([^;]*)(?:(;|$))?`))
  return $match && $match[1]
}

// 删除cookie
export const deleteCookie = name => {
  let date = new Date()
  date.setTime(date.getTime() - 10000)
  document.cookie = name + '=; path=/; expires=' + date.toUTCString()
}

export const getKey = (key, subKey) => {
  const keyStr = localStorage.getItem(key)
  const keyObj = JSON.parse(keyStr)
  if (typeof keyObj !== 'object' || !keyObj) return keyObj
  return subKey ? keyObj[subKey] : keyObj
}

export const setKey = (key, obj) => {
  localStorage.setItem(key, JSON.stringify(obj))
}

export const removeKey = key => {
  localStorage.removeItem(key)
}

export const isEmptyObject = obj => {
  return JSON.stringify(obj) === '{}'
}

const isChinaMobile = new RegExp('^134[0-8]\\d{7}$|^(?:13[5-9]|147|15[0-27-9]|178|1703|1705|1706|18[2-478])\\d{7,8}$')
const isChinaUnion = new RegExp('^(?:13[0-2]|145|15[56]|176|1704|1707|1708|1709|171|18[56])\\d{7,8}$')
const isChinaTelcom = new RegExp('^(?:133|153|1700|1701|1702|177|173|18[019])\\d{7,8}$')

// 运营商判断
export const operatorJudge = mobile => {
  // 中国移动
  if (isChinaMobile.test(mobile)) return 'CM'
  // 中国联通
  if (isChinaUnion.test(mobile)) return 'CU'
  // 中国电信
  if (isChinaTelcom.test(mobile)) return 'CT'
  return 'UN_KNOW'
}

// 判断是否为移动设备
export const isMobile = () => {
  // 首先判段userAgent
  if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
    if (process.env.VUE_APP_CURRENTMODE === 'production') {
      // 生产环境严格检测
      return /(iPhone|Linux armv|Linux aarch64)/i.test(navigator.platform)
    } else {
      // 其他环境随便玩
      return true
    }
  } else {
    return false
  }
}

/**
 * 模拟跳转
 * @param {*} href 外部链接
 */
export const mockHrefJump = (href) => {
  const element = document.createElement('a')
  const ev = document.createEvent('MouseEvents')
  ev.initEvent('click', false, true)
  element.href = href
  document.body.appendChild(element)
  element.dispatchEvent(ev)
  document.body.removeChild(element)
}

/**
 * 复制到剪切板
 * @param {*} message
 */
export const copyToClipbord = (message) => {
  var input = document.createElement('input')
  input.value = message
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, input.value.length)
  document.execCommand('Copy')
  document.body.removeChild(input)
}

/**
 * 判断设备系统
 * @returns {string}
 */
export const judgeClientSystem = () => {
  let client = ''
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    // 判断iPhone|iPad|iPod|iOS
    client = 'IOS'
  } else if (/(Android|Adr)/i.test(navigator.userAgent)) {
    // 判断Android
    client = 'Android'
  } else {
    client = 'PC'
  }
  return client
}

/**
 * 判断浏览器当前使用的语言
 * @returns {string}
 */
export const judgeLanguage = () => {
  // 判断浏览器当前使用的语言
  let currentLanguage = (navigator.browserLanguage || navigator.language).toLowerCase()
  // 非IE
  if (!currentLanguage) {
    // IE浏览器
    currentLanguage = navigator.browserLanguage
  }
  return currentLanguage
}

const wxTag = 'micromessenger'
const BaiduTag = 'swan-baiduboxapp'
const miniProgramTag = 'miniprogram'

/**
 * 判断当前是否是微信小程序环境
 */
export const isWxMiniprogram = () => {
  const ua = navigator.userAgent.toLowerCase()
  return (ua.indexOf(wxTag) !== -1 && ua.indexOf(miniProgramTag) !== -1)
}

/**
 * 判断当前是否是微信小程序环境
 */
export const isTMDMiniprogram = () => {
  return isWxMiniprogram() && getKey('terminal_jsj') === 'JSJ_APPLET'
}



/**
 * 判断当前是否是百度小程序环境
 */
export const isBaiduMiniprogram = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf(BaiduTag) !== -1
}

/**
 * 判断当前是微信环境（且非微信小程序环境）
 * @returns true or false
 */
export const isWxBroswer = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf(wxTag) !== -1 && ua.indexOf(miniProgramTag) === -1
}

export const trySchema = (schema) => {
  return new Promise((resolve, reject) => {
    let node = document.createElement('iframe')
    const body = document.body
    node.style.display = 'none'

    let clear = function (evt, isTimeout) {
      node.onload = null
      body.removeChild(node)
      node = null
    }

    node.onload = clear
    node.src = schema
    body.appendChild(node)
    let now = Date.now()

    setTimeout(() => {
      let newTime = Date.now()

      if (newTime - now > 1100) {
        resolve(true)
      } else {
        resolve(false)
      }
      clear()
    }, 1000)
  })
}

const cacheImgs = []
const cacheIndexs = []

/**
 * 预加载图像
 * @param { string } image
 */
export const preLoadImage = image => {
  var _temp = null
  if (image instanceof Array) {
    image.forEach(item => {
      if (!cacheIndexs.includes(item)) {
        _temp = new Image()
        _temp.src = item
        cacheImgs.push(_temp)
        cacheIndexs.push(item)
      }
    })
  } else {
    if (!cacheIndexs.includes(image)) {
      _temp = new Image()
      _temp.src = image
      cacheImgs.push(_temp)
      cacheIndexs.push(image)
    }
  }
}

/**
 * 获取数组差集
 * @param { array } oscSet 原始数组
 * @param { array } desSet 对比数组
 * @param { function } fn 自定义对比函数
 */
export const getDiffSet = (oscSet, desSet, fn) => {
  return oscSet.filter(item => {
    return fn ? fn(item, desSet) : !desSet.includes(item)
  })
}

// 节流
export const throttle = (func, wait = 50) => {
  let lastTime = 0
  return function (...args) {
    // 当前时间
    let now = +new Date()
    if (now - lastTime > wait) {
      lastTime = now
      func.apply(this, args)
    }
  }
}
// 判断字符是否为表情
export const isEmojiCharacter = (substring) => {
  for (var i = 0; i < substring.length; i++) {
    var hs = substring.charCodeAt(i)
    if (hs >= 0xd800 && hs <= 0xdbff) {
      if (substring.length > 1) {
        var ls = substring.charCodeAt(i + 1)
        var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000
        if (uc >= 0x1d000 && uc <= 0x1f77f) {
          return true
        }
      }
    } else if (substring.length > 1) {
      var rs = substring.charCodeAt(i + 1)
      if (rs === 0x20e3) {
        return true
      }
    } else {
      if (hs >= 0x2100 && hs <= 0x27ff) {
        return true
      } else if (hs >= 0x2B05 && hs <= 0x2b07) {
        return true
      } else if (hs >= 0x2934 && hs <= 0x2935) {
        return true
      } else if (hs >= 0x3297 && hs <= 0x3299) {
        return true
      } else if (hs === 0xa9 || hs === 0xae || hs === 0x303d || hs === 0x3030 ||
        hs === 0x2b55 || hs === 0x2b1c || hs === 0x2b1b ||
        hs === 0x2b50) {
          return true
        }
    }
  }
  return false
}
export const removeBMapIframes = () => {
  setTimeout(() => {
    const nodes = document.querySelectorAll('iframe[src^="https://api.map.baidu.com"]')
    if (nodes && nodes.length) {
      nodes.forEach(item => {
        document.body.removeChild(item)
      })
    }
  }, 600)
}
/**
 * 获取ip
 * @returns {Promise<any>}
 */
export const getIp = () => {
  return new Promise((resolve, reject) => {
    let time = 500
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'ip'
    script.src = 'https://pv.sohu.com/cityjson?ie=utf-8'
    document.body.appendChild(script)
    function start () {
      setTimeout(function () {
        if (typeof returnCitySN !== 'undefined') {
          /* eslint-disable */
                    document.body.removeChild(document.querySelector('#ip'))
                    if (!/(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/.test(returnCitySN.cip)) {
                        reject('')
                    } else {
                        resolve(returnCitySN.cip)
                    }
                } else {
                    if (time <= 3000) {
                        time += 500
                        start()
                    } else {
                        reject(false)
                    }
                }
            }, time)
        }
        start()
    })
}

/**
 * 初始化百融，发送获取GId请求，添加回调，将数据存入localStorage
 * immediately 是否立即获取
 */
export const initGId = (immediately) => {
    return new Promise((resolve, reject) => {
        const cacheGid = getKey('gid')
        if (cacheGid) {
            if (process.env.VUE_APP_ISPRODUCTION === 'true') {
                const gid = document.querySelector('#gid')
                if (!gid) {
                    // 如果没有初始化，就初始化，用于在某些关键节点上传数据
                    const br = window['BAIRONG'] = window['BAIRONG'] || {},
                        script = document.createElement('script'),
                        url = '//static.100credit.com/ifae/js/brcore-v4.0.4.min.js'
                    script.type = "text/javascript"
                    script.charset = "utf-8"
                    script.src = url
                    br.client_id = "3005353"
                    script.id = 'gid'
                    br.config = {
                        timeout: 6000, //请求超时时间
                        islocation: true,
                        iszip: false,
                        isAES: false
                    }
                    document.getElementsByTagName('head')[0].appendChild(script)
                }
            }
            resolve(cacheGid)
        } else {
            const startTime = Date.now()
            const gid = document.querySelector('#gid')
            if (gid) {
                // 已经初始化
                document.getElementsByTagName('head')[0].removeChild(gid)
                window.BAIRONG = null
            }
            const br = window['BAIRONG'] = window['BAIRONG'] || {},
                script = document.createElement('script'),
                url = '//static.100credit.com/ifae/js/brcore-v4.0.4.min.js'
            script.type = "text/javascript"
            script.charset = "utf-8"
            script.src = url
            br.client_id = "3005353"
            script.id = 'gid'
            br.config = {
                timeout: 6000, //请求超时时间
                islocation: true,
                iszip: false,
                isAES: false
            }
            document.getElementsByTagName('head')[0].appendChild(script)
            if (immediately) {
                const init = setInterval(() => {
                    const currentTime = Date.now()
                    const delayTime = 6000
                    if (currentTime - startTime < delayTime) {
                        if (getKey('gid')) {
                            resolve(getKey('gid'))
                            clearInterval(init)
                        }
                    } else {
                        reject()
                    }
                }, 1500)
            }
            br.GidCallBack = response => {
                //data 为请求返回的结果
                if (response.code === 0) {
                    setKey('gid', response.data.gid)
                    resolve(response.data.gid)
                    return
                } else {
                    resolve(false)
                }
            }
            resolve(false)
        }
    })
}

export const isAndroid = () => {
  return judgeClientSystem() === 'Android'
}

export const versionStringCompare = (preVersion='', lastVersion='') => {
    var sources = preVersion.split('.');
    var dests = lastVersion.split('.');
    var maxL = Math.max(sources.length, dests.length);
    var result = 0;
    for (let i = 0; i < maxL; i++) {
        let preValue = sources.length>i ? sources[i]:0;
        let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
        let lastValue = dests.length>i ? dests[i]:0;
        let lastNum =  isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
        if (preNum < lastNum) {
            result = -1;
            break;
        } else if (preNum > lastNum) {
            result = 1;
            break;
        }
    }
    return result;
}